import script from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=284fdc8e&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284fdc8e"]])

export default __exports__